import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
} from "@mui/material";
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded"; // vagy CheckCircleRoundedIcon

const ConfirmStatusModal = ({ open, onClose, onConfirm, isFinalizat }) => {
  const highlightColor = isFinalizat ? "#ffa726" : "#66bb6a";

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="xs"
      disableScrollLock
      PaperProps={{
        sx: {
          borderRadius: "16px",
          padding: 2,
        },
      }}
    >
      <DialogTitle sx={{ textAlign: "center", fontWeight: "bold" }}>
        Confirmare status comandă
      </DialogTitle>

      <DialogContent>
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          textAlign="center"
          py={2}
        >
          <WarningAmberRoundedIcon
            sx={{ fontSize: 50, color: highlightColor, mb: 2 }}
          />

          <Typography variant="body1" fontSize="18px">
            Ești sigur că vrei să marchezi această comandă ca
          </Typography>

          <Typography
            variant="h6"
            fontWeight="bold"
            mt={1}
            sx={{ color: highlightColor }}
          >
            {isFinalizat ? "Neexecutată" : "Finalizată"}?
          </Typography>
        </Box>
      </DialogContent>

      <DialogActions
        sx={{
          justifyContent: "center",
          gap: 3, // több hely a gombok között
          pb: 2,
          px: 3,
        }}
      >
        <Button
          onClick={onClose}
          color="inherit"
          variant="outlined"
          sx={{ borderRadius: "999px", px: 6, py: 2 }}
        >
          Anulează
        </Button>
        <Button
          onClick={onConfirm}
          color="primary"
          variant="contained"
          sx={{ borderRadius: "999px", px: 6, py: 2 }}
        >
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmStatusModal;
